import { render, staticRenderFns } from "./AddRowLayout.vue?vue&type=template&id=dd38e6c4&scoped=true"
import script from "./AddRowLayout.vue?vue&type=script&lang=js"
export * from "./AddRowLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd38e6c4",
  null
  
)

export default component.exports